export default __webpack_public_path__ + "static/media/Ring of the Hierophant.dd15bb7b.jpg";